/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable camelcase */
import dutchMessages from 'ra-language-dutch'
import { StringMap } from 'react-admin'

export const i18nDutch: StringMap = {
  ...dutchMessages,
  dashboard: {
    greeting: {
      morning: 'Goedemorgen',
      afternoon: 'Goedemiddag',
      evening: 'Goedenavond',
    },
    description: 'Welkom bij xxllnc Certificaten.',
    descriptionAdmin: 'Welkom bij xxllnc Certificaten.',
  },
  resources: {
    certificates: {
      list: 'Certificaten',
      edit: 'Gegevens aanpassen',
      show: 'Certificaat details',
      create: 'Certificaat aanvragen',
      title: 'Certificaten',
      actions: {
        createCsr: 'CSR aanmaken',
        uploadCertificate: 'Upload certificaat',
        scheduleInstallation: 'Installatie inplannen',
        cancelInstallation: 'Annuleer installatie',
        renew: 'Vernieuw certificaat',
        renewSuccess: 'Certificaat vernieuwing geinitieerd',
        renewCsr: 'Nieuwe CSR aanmaken',
        csrDownloaded: 'CSR succesvol gedownload',
        downloadCertificate: 'Download certificaat',
        certificateUploaded: 'Certificaat succesvol geüpload',
        certificateDownloaded: 'Certificaat succesvol gedownload',
        installNow: 'Nu installeren',
      },
      fields: {
        properties: 'Eigenschappen',
        kind: 'Soort',
        interface: 'Koppelvlak',
        instance: 'Omgeving',
        host: 'Hostnaam',
        title: 'Titel',
        contactDetails: 'Contactgegevens',
        certificateDetails: 'Certificaat gegevens',
        type: 'Type',
        organisatienaam: 'Organisatienaam',
        provincie: 'Provincie',
        plaatsnaam: 'Plaatsnaam',
        webadres: 'Gewenst webadres',
        webadres_help: 'Het webadres waarvoor het PKI certificaat gebruikt gaat worden. Bijvoorbeeld mijn.gemeente.nl',
        samlKoppeling: 'Soort koppeling',
        samlKoppeling_help: 'Voor welke SAML Koppeling er een certificaat nodig is.',
        samlidp: 'DigiD, eHerkenning en eIDAS',
        stufconfig: 'StUF Koppeling Configuratie',
        stuf_dcr: 'StUF Document Creatie',
        stuf_zkn_client: 'StUF Zaken Client',
        xential: 'Xential',
        api: 'Zaken API',
        event_sink: 'Event Sink',
        export_queue: 'Export Queue',
        gws4all: 'GWS4All',
        omgeving: 'Voor welke omgeving',
        omgeving_help: 'Omgeving url in deze vorm: mijn.gemeente.nl of mijn.alkmaar.nl, ' +
        'niet https://mijn.gemeente.nl of mijn.gemeente.nl/intern',
        koppelvlakId: 'ID van het koppelvlak',
        koppelvlakId_help: 'Koppelvlak ID is het nummer wat achter de naam van de koppeling staat. ' +
        'Bijvoorbeeld StUF Koppeling Configuratie stufconfig(5). Het nummer is in dit geval 5.',
        certificaatId: 'ID van het certificaat',
        municipality: 'Gemeente',
        status: 'Status',
        verloopDatum: 'Verloopdatum',
        url: ', voor \'%{url}\'',
        targetSystem: 'Doelsysteem',
        geldigheid: 'Geldigheid',
      },
      alerts: {
        expired: 'Certificaat is verlopen op %{date}',
        expiresSoon: 'Certificaat verloopt over %{days} dagen op %{date}',
        expiresOn: 'Certificaat verloopt op %{date}',
        noMunicipalityConfigured: 'U kunt nog geen certificaat aanmaken omdat er geen gemeente is geconfigureerd.',
      },
      types: {
        pki: 'PKI',
        zaak_client: 'Client',
      },
      targetSystems: {
        zaken: 'Zaken',
        koppelen: 'Koppelen',
        bezwaren: 'Bezwaren',
      },
      status: {
        PENDING: 'In afwachting',
        CSR_READY: 'CSR gegenereerd',
        CSR_DOWNLOADED: 'CSR gedownload',
        CERT_UPLOADED: 'Certificaat geüpload',
        INSTALL_SCHEDULED: 'Installatie ingepland',
        ACTIVE: 'Actief',
        EXPIRED: 'Verlopen',
        ERROR: 'Fout',
      },
    },
    municipality: {
      list: 'Gemeenten',
      edit: 'Gemeente bewerken',
      show: 'Gemeente',
      create: 'Gemeente toevoegen',
      title: 'Gemeenten',
      fields: {
        organisatienaam: 'Organisatienaam',
        plaatsnaam: 'Plaatsnaam',
        provincie: 'Provincie',
        contactpersoon: 'Contactpersoon',
      },
    },
    organization: {
      list: 'Organisaties',
      edit: 'Organisatie bewerken',
      create: 'Organisatie aanmaken',
      title: 'Organisaties',
      fields: {
        name: 'Naam',
        organizationId: 'Auth0-organisatie-id',
        auth0: 'Auth0-organisatie',
        apps: 'Gekoppelde apps',
        appLinks: 'Koppelingen per app (optioneel)',
      },
      apps: {
        zaken: 'Zaken klant',
      },
      inUseBy: 'gekoppeld aan %{name}',
      sourceUnavailable: 'Bron niet beschikbaar: %{source}. Opslaan is uitgeschakeld.',
      nameMismatch: 'Naam "%{appName}" wijkt af van de Auth0-naam "%{auth0Name}".',
      locked: 'Er zijn certificaten voor deze organisatie; de koppeling kan niet meer gewijzigd worden.',
      authImmutable: 'Het Auth0-id is na opslaan niet meer te wijzigen.',
      confirmTitle: 'Organisatie opslaan?',
      confirmContent: 'Het Auth0-id kan later niet gewijzigd worden.',
      created: 'Organisatie aangemaakt',
      switchTo: 'Wissel naar deze organisatie',
      close: 'Sluiten',
    },
    schedule: {
      fields: {
        installationDatum: 'Installatiedatum',
        dateFieldHelper: 'De tijd zal worden afgerond naar het eerstvolgende hele uur.'
      },
      status: {
        PENDING: 'Installatie ingepland op %{date}',
        COMPLETED: 'Installatie voltooid op %{date}',
        CANCELED: 'Installatie van %{date} geannuleerd',
        ERROR: 'Installatie mislukt op %{date}',
      },
      actions: {
        scheduleInstallationTitle: 'Certificaat installatie inplannen',
        scheduleInstallationSubtitle: 'Kies een datum en tijd voor de installatie van het certificaat',
        dateMustBeInFuture: 'De datum moet in de toekomst liggen',
        canceled: 'Installatie succesvol geannuleerd',
        installationScheduledNow: 'Installatie gestart',
      },
    },
  },
  filters: {
    title: 'Filters',
    status: 'Status',
  },
  data: {
    selectOrganization: 'Kies een organisatie',
    schedule: 'Installatieplanning',
    installationDatum: 'Installatiedatum',
    actions: 'Acties',
    log: 'Logboek',
    properties: 'Eigenschappen',
    lastUpdated: 'Laatst bijgewerkt',
    adres: 'Doel adres',
    certificate: 'Certificaat',
    created: 'Aangemaakt op',
    contactpersoon: 'Contactpersoon',
    phone: 'Telefoonnummer',
    email: 'E-mailadres',
    status: 'Status',
    koppelvlak: 'Koppelvlak',
  },
  login: {
    title: 'Inloggen',
    button: 'Inloggen',
    choose: 'Kies voor welke organisatie je wilt inloggen:',
    email: 'Email',
    emailHint: 'Vul je emailadres in om door te gaan.',
    fetchUserInfo: 'Een moment geduld, we halen je gebruikersinformatie op.',
    hint: 'Log in op xxllnc Certificaten',
    incognitoError: 'Authenticatie niet mogelijk in incognito mode',
    loginCompleted: 'Succesvol ingelogd!',
    unknownOrganizationId: 'Het opgegeven organisatie-id is onbekend',
    notValid: 'Het opgegeven emailadres is niet geldig',
    byXxllnc: 'Certificaten is een applicatie van xxllnc',
    inactive: 'Je bent uitgelogd vanwege inactiviteit.',
  },
  page: {
    unauthorized: {
      headerTitle: 'Onbevoegd',
      defaultTitle: 'Onbevoegd',
      title: 'Voor deze actie ben je niet bevoegd.',
      text: 'Je hebt geprobeerd een actie uit te voeren waar je geen rechten voor hebt.',
    },
  },
  submenu: {
    settings: 'Beheer',
  },
  validation: {
    hostname: 'Ongeldige hostnaam, bijvoorbeeld mijn.gemeente.nl',
  },
}
